import { isValidElement } from 'react';

export const isJSX = (element: object = {}): element is JSX.Element =>
  isValidElement(element);
